export const macDevicesRegExp = /Macintosh|Mac OS X/

export const windowsDevicesRegExp = /Windows/

export const userAgent = navigator.userAgent.toLowerCase()
export const platform = navigator.platform?.toLowerCase() || ''

export const isIPad = (() => {
  if (/ipad/.test(userAgent)) return true
  // iPadOS 13+ 伪装成 Mac，通过触摸点区分
  return /macintosh/.test(userAgent) && navigator.maxTouchPoints > 1
})()

export const isMacOS = /macintosh|mac os x/.test(userAgent) && !isIPad
export const isWindows = /windows|win32|win64/.test(userAgent) || /win/i.test(platform)
